var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, List, Typography, useTheme } from "@mui/material";
import VTButton from "./VTButton";
export default function VTList(_a) {
    var listItems = _a.listItems, title = _a.title, sx = _a.sx;
    var theme = useTheme();
    return (_jsx(Box, __assign({ component: "div", sx: __assign({ bgcolor: theme.palette.background.paper }, sx) }, { children: _jsx(List, __assign({ subheader: title && (_jsx(Typography, __assign({ variant: "body2", sx: { paddingTop: "5px", paddingLeft: "10px" } }, { children: title }))) }, { children: listItems.map(function (listItem) { return (_jsx(VTButton, __assign({ selected: listItem.selected, disabled: listItem.disabled, startIcon: listItem.icon, toolTipOptions: listItem.toolTipOptions, onClick: function () { return listItem.onClick && listItem.onClick(listItem); }, type: "list" }, { children: listItem.name }))); }) })) })));
}
